const BASE_PATH = `/images/nutrition-and-rehabilitation`;

const assessmentImage = {
  // section images
  nutritionSection: `${BASE_PATH}/nutrition-section.svg`,
  waterSection: `${BASE_PATH}/water-section.svg`,
  sleepSection: `${BASE_PATH}/sleep-section.svg`,

  // landing
  landingBgDetail: `${BASE_PATH}/landing-bg-detail.svg`,

  // category images
  nutritionImage: `${BASE_PATH}/nutrition-image.svg`,
  waterImage: `${BASE_PATH}/water-image.svg`,
  sleepImage: `${BASE_PATH}/sleep-image.svg`,
  behaviorImage: `${BASE_PATH}/behavior-image.svg`,

  // exercise category images
  exerciseImage: `${BASE_PATH}/exercise-image.svg`,
  walkingImage: `${BASE_PATH}/walking-image.svg`,
  exerciseBehaviorImage: `${BASE_PATH}/exercise-behavior-image.svg`,
  exerciseBehaviorSection: `${BASE_PATH}/exercise-behavior-section.svg`,
  muscleImage: `${BASE_PATH}/muscle-image.svg`,
  exerciseConfidenceImage: `${BASE_PATH}/confidence-image.svg`,
  exerciseConfidenceSection: `${BASE_PATH}/confidence-section.svg`,
  exerciseSection: `${BASE_PATH}/exercise-section.svg`,
  
  exerciseTip: `${BASE_PATH}/exercise-tip.svg`,

  // icons
  numberOfItem: `${BASE_PATH}/number-of-item.svg`,
  chevronRight: `${BASE_PATH}/chevron-right.svg`,
  information: `${BASE_PATH}/information.svg`,
  tipIcon: `${BASE_PATH}/tip-icon.svg`,

  // metabolism category images
  metabolismImage: `${BASE_PATH}/metabolism-image.svg`,
  bloodSugarImage: `${BASE_PATH}/blood-sugar-image.svg`,
  fatBurnImage: `${BASE_PATH}/fat-burn-image.svg`,
  tipMetabolismImage: `${BASE_PATH}/tip-metabolism-image.svg`,
  bmiImage: `${BASE_PATH}/bmi-image.svg`,
  waistImage: `${BASE_PATH}/waist-image.svg`,
  bodyFatImage: `${BASE_PATH}/body-fat-image.svg`,

  // stress category images
  stressImage: `${BASE_PATH}/stress-image.svg`,
  tipStressImage: `${BASE_PATH}/tip-stress-image.svg`,
  mentalHealthImage: `${BASE_PATH}/mental-health-image.svg`,
  gutGroupImage: `${BASE_PATH}/gut-group-image.svg`,

  // gut balance category images
  gutBalanceImage: `${BASE_PATH}/gut-balance-image.svg`,
  digestionImage: `${BASE_PATH}/digestion-image.svg`,
  gutHabitImage: `${BASE_PATH}/gut-habit-image.svg`,
  gutImage: `${BASE_PATH}/gut-image.svg`,
  tipGutImage: `${BASE_PATH}/tip-gut-image.svg`,

  // skin category images
  skinImage: `${BASE_PATH}/skin-image.svg`,
  tipSkinImage: `${BASE_PATH}/tip-skin-image.svg`,
  wrinkleImage: `${BASE_PATH}/wrinkle-image.svg`,
  darkSpotImage: `${BASE_PATH}/dark-spot-image.svg`,
  saggingImage: `${BASE_PATH}/sagging-image.svg`,
  skinOtherImage: `${BASE_PATH}/skin-other-image.svg`,

  vetgetableImage: `${BASE_PATH}/vetgetable.svg`
};

export default assessmentImage;
